// extracted by mini-css-extract-plugin
export var parcelRow = "_th-0";